export default "__VITE_ASSET__03x0Uh_V__"